"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgCloudRainOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.cloud-rain_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "cloud-rain_outline_svg__transparent_box" },
            React.createElement("path", { className: "cloud-rain_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "cloud-rain_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "cloud-rain_outline_svg__OUTLINE" },
            React.createElement("path", { transform: "rotate(-71.57 20.996 26.002)", d: "M17.84 25h6.32v2h-6.32z" }),
            React.createElement("path", { transform: "rotate(-71.57 9.002 26)", d: "M5.84 25h6.32v2H5.84z" }),
            React.createElement("path", { transform: "rotate(-71.57 14.999 26)", d: "M11.84 25h6.32v2h-6.32z" }),
            React.createElement("path", { d: "M22.64 7.11A7 7 0 0016 2.5 6.89 6.89 0 009 9v.1A5.5 5.5 0 0010 20h11.5a6.49 6.49 0 001.14-12.89zM21.5 18H10a3.5 3.5 0 010-7h1V9.08a4.9 4.9 0 015-4.58 5 5 0 014.88 3.74l.17.73h.74a4.49 4.49 0 01-.29 9z" }))));
}
exports.default = SvgCloudRainOutline;
//# sourceMappingURL=CloudRainOutline.js.map